import { useEffect, useRef } from 'react'
import { useUser } from '@clerk/clerk-react'
import { usePostHog } from 'posthog-js/react'

/**
 * Syncs Clerk auth state with PostHog identity.
 * - Identifies logged-in users by Clerk user ID
 * - Fires signup_completed once for newly-registered accounts (within 60s of creation)
 * - Resets PostHog identity on sign-out
 *
 * Call this once in App.tsx alongside useApiAuth().
 */
export function usePostHogIdentify() {
  const { user, isLoaded } = useUser()
  const posthog = usePostHog()
  const signupFired = useRef(false)

  useEffect(() => {
    if (!isLoaded) return

    if (user) {
      posthog.identify(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        created_at: user.createdAt,
        subscription_tier: null, // TODO: populate from /api/users/me when billing ships
      })

      // Fire signup_completed for new registrations (account created within the last 60s)
      const ageMs = Date.now() - new Date(user.createdAt!).getTime()
      if (ageMs < 60_000 && !signupFired.current) {
        signupFired.current = true
        posthog.capture('signup_completed', {
          referrer: document.referrer || undefined,
        })
      }
    } else {
      posthog.reset()
    }
  }, [user, isLoaded, posthog])
}
